import { AIChatBoxMessagesInterceptor, systemMessage, temporaryText } from '@aston/ai-chat';
import { TranslateService } from '@ngx-translate/core';
import { inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'any' })
export class ConsoleAIChatBoxMessagesInterceptor extends AIChatBoxMessagesInterceptor {
	i18n = inject(TranslateService)

	generateTemporaryButtons(_text: string) {
		const buttons = []

		if (this.isFlakyResponse()) {
			this.buttonsFromFlakyResponse().forEach(b => buttons.push(b))
		}

		return systemMessage({ html: temporaryText(buttons.join('')) })
	}

	replaceWellKnownTokens(text: string) {
		this.trackFlakyResponse(text)

		return this.replaceTextAndEntityTokens(text, value => value
			.replace(/【[^】]*】/g, '') // remove files references
			.replace(/08\s*90\s*21\s*38\s*39/g, `[08 90 21 38 39](tel:${this.i18n.instant('Support.Phone')})`)
			.replace(/\+33\s*8\s*90\s*21\s*38\s*39/g, `[08 90 21 38 39](tel:${this.i18n.instant('Support.Phone')})`)
			.replace(/support@astonai.com/g, `[${this.i18n.instant('Support.Email')}](mailto:${this.i18n.instant('Support.Email')})`))
	}
}
